import { useRouter } from 'next/router';
import { useEffect } from 'react';
import { usePageProps } from '../page-props-provider';
import { useRudderstackClient } from './rudderstack-provider';
export function useRSPageView(pageType, productDetails) {
    var RudderstackClient = useRudderstackClient().RudderstackClient;
    var pageProps = usePageProps();
    var router = useRouter();
    // biome-ignore lint/correctness/useExhaustiveDependencies: router.asPath is the navigation signal. pageType and visitor_id_cookie are stable per page load. productDetails is recomputed (new object) each render but is intentionally snapshotted at navigation time — variant changes must not re-fire the event. Relies on PDP props being synchronous with the route.
    useEffect(function () {
        if (!RudderstackClient)
            return;
        // Defer to a microtask so this page call runs after RudderstackIdentifyTracking's
        // queued identify() microtask. Because RudderstackIdentifyTracking appears before
        // page components in the React tree, its microtask is queued first and runs first,
        // ensuring userId is already set in SDK state when the page event fires.
        queueMicrotask(function () {
            var _a;
            RudderstackClient.page('', '', {
                rb_visitor_id: (_a = pageProps.userProperties) === null || _a === void 0 ? void 0 : _a.visitor_id_cookie,
                page_type: pageType,
                product_details: productDetails,
            });
        });
    }, [RudderstackClient, router.asPath]);
}
